module.exports = __webpack_public_path__ + "img/ic-interpayment-white.e7a33b92.svg";